const AVATAR_PREFIX = 'developmentexpress_avatar_';

const getPendingKey = (role) => `developmentexpress_avatar_pending_${role || 'user'}`;

export const PHOTO_REMOVED_FLAG_OWNER = 'developmentexpress_photo_removed_owner';

function isSignedProfilePhotoUrl(url) {
  const s = String(url || '');
  return s.includes('token=') || s.includes('supabase');
}

function shouldPersistAvatarToStorage(url) {
  const s = String(url || '');
  if (isSignedProfilePhotoUrl(s)) return false;
  if (!s.startsWith('data:')) return false;
  if (s.startsWith('https://') && s.includes('storage')) return false;
  return true;
}

export function avatarStorageKey(userId) {
  if (!userId) return null;
  return `${AVATAR_PREFIX}${userId}`;
}

export function loadProfilePhoto(userId, role) {
  try {
    if (role === 'owner' && localStorage.getItem(PHOTO_REMOVED_FLAG_OWNER) === '1') {
      return '';
    }
    if (userId) {
      const stored = localStorage.getItem(avatarStorageKey(userId)) || '';
      if (stored && !isSignedProfilePhotoUrl(stored)) {
        return stored;
      }
      return localStorage.getItem(getPendingKey(role)) || '';
    }
    return localStorage.getItem(getPendingKey(role)) || '';
  } catch {
    return '';
  }
}

export function saveProfilePhoto(userId, dataUrl, role) {
  try {
    if (!dataUrl || !shouldPersistAvatarToStorage(dataUrl)) return;
    if (userId) {
      localStorage.setItem(avatarStorageKey(userId), dataUrl);
    } else {
      localStorage.setItem(getPendingKey(role), dataUrl);
    }
  } catch {
    /* quota / private mode */
  }
}

export function clearProfilePhoto(userId, role) {
  try {
    if (userId) {
      localStorage.removeItem(avatarStorageKey(userId));
    } else {
      localStorage.removeItem(getPendingKey(role));
    }
  } catch {
    /* ignore */
  }
}

/** After login, attach pending registration photo to user id. */
export function commitPendingProfilePhoto(userId, role) {
  if (!userId) return;
  try {
    const pending = loadProfilePhoto(null, role);
    if (pending && userId) {
      saveProfilePhoto(userId, pending);
      clearProfilePhoto(null, role);
    }
  } catch {
    /* ignore */
  }
}

/** Cache signed URL from API on user object. */
export function syncUserProfilePhoto(user) {
  if (!user?.id) return user;
  try {
    const profilePhotoUrl = user.profilePhotoUrl ? String(user.profilePhotoUrl) : '';
    if (profilePhotoUrl && !isSignedProfilePhotoUrl(profilePhotoUrl) && shouldPersistAvatarToStorage(profilePhotoUrl)) {
      localStorage.setItem(avatarStorageKey(user.id), profilePhotoUrl);
    }
    const stored = JSON.parse(localStorage.getItem('developmentexpress_user') || '{}');
    if (stored?.id === user.id) {
      localStorage.setItem('developmentexpress_user', JSON.stringify({ ...stored, ...user }));
    }
  } catch {
    /* ignore */
  }
  return user;
}
